import {FieldWrapper, type IFieldState} from "@pg-design/inputs-module";

import {CalendarSlider} from "../components/CalendarSlider";
import type {ICalendarDate} from "../types/ICalendarDate";
import {type ICalendarSliderProps} from "../types/ICalendarSliderProps";

import * as styles from "./CalendarSliderField.module.css";

type IProps = Omit<ICalendarSliderProps, "onChange"> & {
    labelContent?: string;
    errorMessage?: string;
    fieldState?: IFieldState;
    onChange: (value: ICalendarDate) => void;
};

export const CalendarSliderField = (props: IProps) => {
    const {labelContent, fieldState, errorMessage, onChange, ...restProps} = props;

    return (
        <FieldWrapper labelContent={labelContent} fieldState={fieldState} message={errorMessage}>
            <CalendarSlider
                onChange={(newValue) => {
                    onChange(newValue);
                }}
                sliderClassName={errorMessage && styles.sliderError}
                {...restProps}
            />
        </FieldWrapper>
    );
};
import {FieldWrapper, type IFieldState} from "@pg-design/inputs-module";

import {CalendarSlider} from "../components/CalendarSlider";
import type {ICalendarDate} from "../types/ICalendarDate";
import {type ICalendarSliderProps} from "../types/ICalendarSliderProps";

import * as styles from "./CalendarSliderField.module.css";

type IProps = Omit<ICalendarSliderProps, "onChange"> & {
    labelContent?: string;
    errorMessage?: string;
    fieldState?: IFieldState;
    onChange: (value: ICalendarDate) => void;
};

export const CalendarSliderField = (props: IProps) => {
    const {labelContent, fieldState, errorMessage, onChange, ...restProps} = props;

    return (
        <FieldWrapper labelContent={labelContent} fieldState={fieldState} message={errorMessage}>
            <CalendarSlider
                onChange={(newValue) => {
                    onChange(newValue);
                }}
                sliderClassName={errorMessage && styles.sliderError}
                {...restProps}
            />
        </FieldWrapper>
    );
};
